module.exports = __webpack_public_path__ + "img/1440.147a247b.jpg";